<template>
  <div id="sign-in-email" class="container">
    <b-field label="メールアドレス" :type="emailInputClass">
      <b-input type="email" v-model="email"></b-input>
    </b-field>
    <b-field label="パスワード" :type="passwordInputClass">
      <b-input type="password" v-model="password" password-reveal></b-input>
    </b-field>
    <b-button type="is-primary" @click="signIn" expanded class="pandorabutton">
      サインインする
    </b-button>
  </div>
</template>

<script>
import { auth } from '@/plugins/firebase';
export default {
  name: 'SingInEmail',
  data() {
    return {
      email: '',
      password: '',
      emailInputClass: '',
      passwordInputClass: ''
    };
  },
  methods: {
    async signIn() {
      try {
        await auth.signInWithEmailAndPassword(this.email.trim(), this.password);
        this.$router.push('/home');
      } catch (err) {
        let message =
          'ログインできなくなっています。しばらく経ってからまたお試しください。';

        switch (err.code) {
          case 'auth/invalid-email':
            message = 'メールのフォーマットが間違っています。';
            break;
          case 'auth/user-disabled':
            message = 'ユーザーが無効化されました。';
            break;
          case 'auth/user-not-found':
            message = 'ユーザーが存在していなません。';
            break;
          case 'auth/wrong-password':
            message = 'パスワードが間違っています。';
            break;
          case 'auth/too-many-requests':
            message =
              'ログイン失敗の回数の上限に達しました。しばらく経ってからまたお試しください。';
            break;
        }

        this.emailInputClass = 'is-danger';
        this.passwordInputClass = 'is-danger';

        this.$buefy.toast.open({
          duration: 3500,
          message: message,
          type: 'is-danger'
        });
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
